import { render } from "./transaction_history.vue?vue&type=template&id=1feaacd2"
import script from "./transaction_history.vue?vue&type=script&lang=js"
export * from "./transaction_history.vue?vue&type=script&lang=js"

import "./transaction_history.vue?vue&type=style&index=0&id=1feaacd2&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__